/**
 * Fout met behoud van de HTTP-status. Bewust een losse module: consumers die
 * alleen een status hoeven te duiden (zie domains/auth/meFailure.ts) trekken zo
 * niet de hele api-client — en daarmee MSAL — in hun importgraaf.
 */
export class ApiError extends Error {
  constructor(public readonly status: number, message: string) {
    super(message);
    this.name = 'ApiError';
  }
}

export function apiError(status: number, statusText: string): ApiError {
  return new ApiError(status, `API error: ${status} ${statusText}`);
}
